import { render, staticRenderFns } from "./BillingFrequencySelector.yaml?vue&type=template&id=0cfe009a&component"
import script from "./BillingFrequencySelector.yaml?vue&type=script&lang=ts&component"
export * from "./BillingFrequencySelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports